// extracted by mini-css-extract-plugin
export var subtitle = "_b3-2";
export var title = "_b3-0";
export var titleNoWrap = "_b3-1";